// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportModalFilter_root__2s9J1","footer":"ReportModalFilter_footer__3kwco"};